import type { ReactNode } from 'react'

// Angled "Under Construction" ribbon badge, overlaid on a disabled button.
// The wrapper keeps the button's footprint so layouts don't shift.
export default function UnderConstruction({
  children,
  onOverlayClick,
  className = '',
}: {
  children: ReactNode
  onOverlayClick?: () => void
  className?: string
}) {
  return (
    <div className={`relative inline-block ${className}`}>
      {children}
      {/* click shield — the wrapped button stays disabled underneath */}
      <div
        className={`absolute inset-0 rounded-lg ${onOverlayClick ? 'cursor-pointer' : ''}`}
        aria-hidden={!onOverlayClick}
        onClick={onOverlayClick}
      />
      <div className="absolute inset-0 overflow-hidden rounded-lg pointer-events-none">
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rotate-[-14deg] whitespace-nowrap bg-yellow-400/95 text-black text-[10px] font-bold uppercase tracking-widest px-10 py-0.5 shadow-[0_1px_4px_rgba(0,0,0,0.6)]">
          Under construction
        </div>
      </div>
    </div>
  )
}
